import {ChangeDetectionStrategy, Component, OnInit, inject} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {ContentComponent} from '../../../shared/elements/content/content.component';
import {FormButtonComponent} from '../../../shared/elements/form-button/form-button.component';
import {HeadlineComponent} from '../../../shared/elements/headline/headline.component';
import {IconBadgeComponent} from '../../../shared/elements/icon-badge/icon-badge.component';
import {TranslatePipe} from '../../../shared/pipes/translate.pipe';
import {DialogDocumentsAttachmentsComponent} from '../../documents/dialog-documents-attachments/dialog-documents-attachments.component';
import {FeedbackAttemptCompletionComponent} from '../feedback-attempt-completion.component';
import {FeedbackQuestionWrapperComponent} from '../feedback-question-types/feedback-question-wrapper/feedback-question-wrapper.component';
import {FeedbackAttemptPageController} from './feedback-attempt-page-controller.service';

@Component({
	selector: 'app-feedback-attempt-page',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		'(window:beforeunload)': 'handleBeforeUnload()',
	},
	imports: [
		ContentComponent,
		DialogDocumentsAttachmentsComponent,
		FeedbackAttemptCompletionComponent,
		FeedbackQuestionWrapperComponent,
		FormButtonComponent,
		HeadlineComponent,
		IconBadgeComponent,
		ReactiveFormsModule,
		TranslatePipe,
	],
	providers: [FeedbackAttemptPageController],
	templateUrl: './feedback-attempt-page.component.html',
})
export class FeedbackAttemptPageComponent implements OnInit {
	private controller: FeedbackAttemptPageController = inject(FeedbackAttemptPageController);

	public readonly controlNamePrefix: FeedbackAttemptPageController['controlNamePrefix'] = this.controller.controlNamePrefix;
	public readonly attemptForm: FeedbackAttemptPageController['attemptForm'] = this.controller.attemptForm;
	public readonly missingContext: FeedbackAttemptPageController['missingContext'] = this.controller.missingContext;
	public readonly displayAttachmentsDialog: FeedbackAttemptPageController['displayAttachmentsDialog'] = this.controller.displayAttachmentsDialog;
	public readonly formControlsReady: FeedbackAttemptPageController['formControlsReady'] = this.controller.formControlsReady;
	public readonly isSaving: FeedbackAttemptPageController['isSaving'] = this.controller.isSaving;
	public readonly oneByOneStarted: FeedbackAttemptPageController['oneByOneStarted'] = this.controller.oneByOneStarted;
	public readonly oneByOneQuestionIndex: FeedbackAttemptPageController['oneByOneQuestionIndex'] = this.controller.oneByOneQuestionIndex;
	public readonly oneByOneRemainingSeconds: FeedbackAttemptPageController['oneByOneRemainingSeconds'] = this.controller.oneByOneRemainingSeconds;
	public readonly oneByOneQuestionExpired: FeedbackAttemptPageController['oneByOneQuestionExpired'] = this.controller.oneByOneQuestionExpired;
	public readonly context: FeedbackAttemptPageController['context'] = this.controller.context;
	public readonly presentation: FeedbackAttemptPageController['presentation'] = this.controller.presentation;
	public readonly completionMode: FeedbackAttemptPageController['completionMode'] = this.controller.completionMode;
	public readonly hasVisibleAuthenticatedCompletion: FeedbackAttemptPageController['hasVisibleAuthenticatedCompletion'] = this.controller.hasVisibleAuthenticatedCompletion;
	public readonly completionVisible: FeedbackAttemptPageController['completionVisible'] = this.controller.completionVisible;
	public readonly isOneByOne: FeedbackAttemptPageController['isOneByOne'] = this.controller.isOneByOne;
	public readonly questions: FeedbackAttemptPageController['questions'] = this.controller.questions;
	public readonly displayedQuestions: FeedbackAttemptPageController['displayedQuestions'] = this.controller.displayedQuestions;
	public readonly shouldShowOneByOneIntro: FeedbackAttemptPageController['shouldShowOneByOneIntro'] = this.controller.shouldShowOneByOneIntro;
	public readonly shouldShowQuestionForm: FeedbackAttemptPageController['shouldShowQuestionForm'] = this.controller.shouldShowQuestionForm;
	public readonly activeOneByOneQuestionIndex: FeedbackAttemptPageController['activeOneByOneQuestionIndex'] = this.controller.activeOneByOneQuestionIndex;
	public readonly activeOneByOneQuestion: FeedbackAttemptPageController['activeOneByOneQuestion'] = this.controller.activeOneByOneQuestion;
	public readonly activeOneByOneQuestionNumber: FeedbackAttemptPageController['activeOneByOneQuestionNumber'] = this.controller.activeOneByOneQuestionNumber;
	public readonly hasActiveOneByOneTimer: FeedbackAttemptPageController['hasActiveOneByOneTimer'] = this.controller.hasActiveOneByOneTimer;
	public readonly activeOneByOneQuestionLocked: FeedbackAttemptPageController['activeOneByOneQuestionLocked'] = this.controller.activeOneByOneQuestionLocked;
	public readonly activeOneByOneTimerText: FeedbackAttemptPageController['activeOneByOneTimerText'] = this.controller.activeOneByOneTimerText;
	public readonly isLastOneByOneQuestion: FeedbackAttemptPageController['isLastOneByOneQuestion'] = this.controller.isLastOneByOneQuestion;
	public readonly canSubmit: FeedbackAttemptPageController['canSubmit'] = this.controller.canSubmit;
	public readonly canFinishAttempt: FeedbackAttemptPageController['canFinishAttempt'] = this.controller.canFinishAttempt;
	public readonly canAdvanceOneByOne: FeedbackAttemptPageController['canAdvanceOneByOne'] = this.controller.canAdvanceOneByOne;

	public ngOnInit(): void {
		this.controller.initialize();
	}

	public handleBeforeUnload(): void {
		this.controller.handleBeforeUnload();
	}

	public navigateBack(): void {
		this.controller.navigateBack();
	}

	public displayClass(): string {
		return this.controller.displayClass();
	}

	public startOneByOneFlow(): void {
		this.controller.startOneByOneFlow();
	}

	public showNextQuestion(): void {
		this.controller.showNextQuestion();
	}

	public submitAttempt(): void {
		this.controller.submitAttempt();
	}

	public hasValidationError(question: Parameters<FeedbackAttemptPageController['hasValidationError']>[0]): boolean {
		return this.controller.hasValidationError(question);
	}

	public hasRequiredAnswerError(question: Parameters<FeedbackAttemptPageController['hasRequiredAnswerError']>[0]): boolean {
		return this.controller.hasRequiredAnswerError(question);
	}
}
